import { Expose } from 'class-transformer';
import { SafeUrl } from '@angular/platform-browser';

export class SponsoredAdEntity {
  id: number;
  @Expose({ name: 'bannerName' })
  title: string;

  @Expose({ name: 'description' })
  subTitle: string;

  @Expose({ name: 'redirectLink' })
  url: string;

  // For UI use only
  imageUrl: string | SafeUrl;
}

export class AdImage {
  @Expose({ name: 'banner_id' })
  adId: number;

  @Expose({ name: 'banner_image' })
  adImage: string;
}
